var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('b-row',{attrs:{"align-h":"center"}},[_c('div',{staticClass:"spinner-3dot"},[_c('div',{staticClass:"bounce-1"}),_vm._v(" "),_c('div',{staticClass:"bounce-2"}),_vm._v(" "),_c('div',{staticClass:"bounce-3"})])])}
var staticRenderFns = []

export { render, staticRenderFns }